import { Container } from 'react-bootstrap';
import { useState } from 'react';
import Pager from './Pager';

const PagerDemo = () => {
  const [currPage, setCurrPage] = useState(1);

  console.log(currPage);

  return (
    <Container>
      <h4>Pager</h4>
      <Pager pagesSize={3} currentPage={currPage} onPageChange={setCurrPage} />
    </Container>
  );
};
export default PagerDemo;
